<template>
  <div class="PaymentRecord">
    <!-- 查询当月未进行服务的老人列表 -->
    <el-row>
      <el-form :inline="true" :model="addForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="月份">
          <el-date-picker v-model="addForm.yearMonth" :clearable="false" type="month" value-format="yyyy-MM"
            placeholder="请选择月份" />
        </el-form-item>
        <el-form-item label="老人姓名">
          <el-input v-model="addForm.oldmanName" placeholder="请输入老人姓名" clearable
            @keyup.enter.native.prevent="enterSearch"></el-input>

        </el-form-item>
        <el-form-item label="所属乡镇">
          <el-select v-model="addForm.community" style="width:200px" placeholder="请选择">
            <el-option v-for="item in areaList" :key="item.dictName" :label="item.dictName" :value="item.dictName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="老人类别">
          <el-input v-model="addForm.oldTypeName" placeholder="请输入老人类别" clearable
            @keyup.enter.native.prevent="enterSearch"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="queryTable">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="info" icon="el-icon-upload" plain @click="downLoad">导出</el-button>
        </el-form-item>

      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table :data="tableData" :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle"
        style="width: 100%">
        <el-table-column type="index" label="序号" :index="indexMethod" width="60">
        </el-table-column>
        <el-table-column prop="oldName" label="老人姓名" align="center" min-width="90"></el-table-column>
        <el-table-column prop="sex" label="性别" min-width="50">
          <template slot-scope="scope">
            {{ scope.row.sex == 0 ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="oldAge" label="年龄" min-width="50"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" min-width="170"></el-table-column>
        <el-table-column prop="cardAddress" label="所属乡镇" min-width="120"></el-table-column>
        <el-table-column prop="oldAddress" label="家庭住址" min-width="190" show-overflow-tooltip></el-table-column>
        <el-table-column prop="interest" label="老人类别" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remainder" label="当月服务次数" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="option" label="详情" min-width="180px" align="center">
          <template slot-scope="scope">
            <el-button style="margin-right: 5px" type="primary" size="mini" plain
              @click="showConsumption(scope.row)">服务明细</el-button>
               <el-button style="margin-left: 5px" type="warning" size="mini" plain
              @click="showCancel(scope.row)">原因填写</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination class="fenye" background layout="total,prev, pager, next" :total="total" :current-page.sync="pageNum"
      @current-change="changePage" align="center"></el-pagination>


    <!-- 消费记录 -->
    <el-dialog title="服务记录" width="70%" :visible.sync="dialogConsumption" :close-on-click-modal="false">
      <el-table :data="consumptionRecordList" style="width: 100%"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="{ 'height': '30px' }" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }">
        <el-table-column prop="oldmanName" label="老人姓名" width="150px" align="center"></el-table-column>
        <el-table-column prop="serviceContent" label="服务内容" width="350px" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="userNameGet" label="服务人员" width="150px" align="center"></el-table-column>
        <el-table-column prop="serviceAddress" label="服务地址" width="200px" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="服务时间" align="center" width="200px"></el-table-column>
      </el-table>
      <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
        layout="total, prev, pager, next" :total="consumptionTotal" :page-size="pageSize" align="center"
        class="fenye"></el-pagination>
    </el-dialog>


    <el-dialog class="weeklymenudialog" title="未服务情况说明" width="900px" :visible.sync="dialogCancel"
      :close-on-click-modal="false" center>
      <el-form :model="addCancelForm" label-width="100px" style="margin-top: 0px;" ref="addFoodaa"
        label-position="right">
        <el-row>
          <el-col :span="12">
            <el-form-item label="老人姓名">
              <el-input v-model.trim="addCancelForm.oldmanName" readonly style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model.trim="addCancelForm.oldmanCard" readonly style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="乡镇">
              <el-input v-model.trim="addCancelForm.street" style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="村">
              <el-input v-model.trim="addCancelForm.community" style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="家庭住址">
              <el-input v-model.trim="addCancelForm.address" style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请月份">
              <el-input v-model.trim="addCancelForm.yearMonth" readonly style="width:95%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="申请原因">
              <el-input v-model.trim="addCancelForm.remark" style="width:95%;" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="附件照片">
              <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card" :file-list="addFileList"
                :before-upload="beforeAvatarUploadPicB" :http-request="uploadSectionFilePicB" :on-remove="handleRemove"
                :on-preview="handlePictureCardPreview" :limit="5">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel = false">
          取消</el-button>
        <el-button type="primary" @click="submitFormAddCancel">
          确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="640px" style="margin-top: -50px;">
      <img width="600px" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>
<script>
import util from "@/utils/util.js";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      tableData: [], //老人列表数据
      addForm: {
        oldmanName: "", //搜索查询老人
        community: "",
        yearMonth: util.formatDate.format(new Date(), 'yyyy-MM'), //搜索查询老人身份证
        oldTypeName: "",
      },
      areaList: [],
      dialogChargeVisible: false,
      dialogConsumption: false,
      dialogRecharge: false,
      consumptionRecordList: [],
      consumptionPage: 1,
      rechargePage: 1,
      consumptionTotal: 0,
      quertForm: {},
      dialogCancel: false,
      formLabelWidth: "100px",
      chargeForm: {},
      chargeLoading: false,
      dialogVisible:false,
      dialogImageUrl:'',
      addFileList:[],
      addCancelForm:{
        remark:'',
        community:'',
        street:'',
      },
      //分页
      groupId: 0,
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      checkBill: [],
    };
  },
  methods: {
    showConsumption(row) {
      this.consumptionPage = 1;
      this.consumptionTotal = 0;
      this.dialogConsumption = true;
      this.consumptionRecordList = [];
      this.quertForm = {
        oldId: row.oldmanId,
        statusList: [0, 1, 2, 3, 4, 5, 6, 7]
      }
      this.queryConsumptionList();
    },

    showCancel(row){
      this.dialogCancel = true;
      console.log(row);
      this.addCancelForm.oldmanName = row.oldName;
      this.addCancelForm.oldmanCard = row.oldIdCard;
      this.addCancelForm.oldmanId = row.oldmanId;
      this.addCancelForm.oldmanPhone = row.oldPhone;
      this.addCancelForm.community = '';
      this.addCancelForm.address = row.oldAddress;
      this.addCancelForm.street = row.cardAddress;
      this.addCancelForm.oldType = row.interest;
      this.addCancelForm.remark = '';
      this.addCancelForm.affixUrl = '';
      this.addCancelForm.currentYear = this.addForm.yearMonth.split("-")[0];
      this.addCancelForm.currentMonth =this.addForm.yearMonth.split("-")[1];
      this.addCancelForm.yearMonth = this.addForm.yearMonth;
      this.addFileList = [];
      this.addCancelForm.addFileUrl = [];
    },
    submitFormAddCancel(){
      console.log(this.addCancelForm);
      this.addCancelForm.affixUrl = this.addCancelForm.addFileUrl.join(",");
      // if(this.addCancelForm.affixUrl == ""){
      //   this.$message({
      //     message: '请上传附件',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      if(this.addCancelForm.remark == ""){
        this.$message({
          message: '请填写原因',
          type: 'warning'
        });
        return false;
      }
      this.$postJson('omc/notServiceOldReason/addAbnormalApplication',this.addCancelForm).then(res => {
        this.dialogCancel = false;
        this.$message({
              message: res.message
        });
      })


    },
    beforeAvatarUploadPicB(file) {
      let isPNG = false;
      let isImage = false;
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB");
      }
      //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
      if (isPNG && isLt2M && isImage) {
        return true;
      }
      return isPNG && isLt2M && isImage;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file);
      console.log(this.addFileList);
      for (let i = 0; i < this.addFileList.length; i++) {
        if (file.uid == this.addFileList[i].uid) {
          this.addFileList.splice(i, 1);
          this.addCancelForm.addFileUrl.splice(i, 1);
        }
      }
      console.log(this.addCancelForm.addFileUrl);
    },
    uploadSectionFilePicB(param) {
      var fileObj = param.file;
        console.log(param);
      if (fileObj != undefined) {
        console.log(fileObj);
       
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.addCancelForm.addFileUrl.push(res.result);
            fileObj.url = res.result;
             this.addFileList.push(fileObj);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    getAreaList() {
      this.$postJson('mdc/dict/queryDictSubListByDictCode/area_' + this.groupId).then(res => {
        this.areaList = res.result;
      })
    },
    indexMethod(index) {
      return (Number(this.pageNum - 1) * Number(this.pageSize)) + index + 1;
    },
    consumptionPageChange(val) {
      this.consumptionPage = val;
      this.queryConsumptionList();
    },
    queryConsumptionList() {
      let param = {
        oldmanId: this.quertForm.oldId,
        pageNum: this.consumptionPage,
        pageSize: this.pageSize,
        statusList: [8]
      };
      this.$postJson("omc/serviceOrder/orderList", param).then((res) => {
        this.consumptionRecordList = res.result.list; //列表数据
        this.consumptionTotal = Number(res.result.total); //页码total
      });
    },
    formattype2(row) {
      if (row.type == 5) {
        if (row.projectType == "1") {
          return "现金支付";
        } else if (row.projectType == "2") {
          return "刷卡支付";
        } else if (row.projectType == "3") {
          return "移动支付";
        } else {
          return row.projectType;
        }
      } else {
        return row.projectType;
      }
    }
    ,
    formatType(row) {
      // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
      if (row.type == 0) {
        return "按天消费";
      } else if (row.type == 1) {
        return "按月消费";
      } else if (row.type == 2) {
        return "单次服务收费";
      } else if (row.type == 5) {
        return "充值";
      } else if (row.type == 6) {
        return "请假退费";
      } else if (row.type == 7) {
        return "出院退费";
      } else {
        return "其他费用";
      }
    },
    inputChange1(val) {
      //限制输入数字和两位小数;
      this.chargeForm.rechargePrice = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    /* 
     模糊查询老人
     */
    querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //查询欠费列表
    queryPayList() {
      let param = {
        oldmanName: this.addForm.oldmanName,
        yearMonth: this.addForm.yearMonth,
        oldTypeName: this.addForm.oldTypeName,
        community: this.addForm.community,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/serviceOrder/queryNotServiceOldList", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
      });
    },
    //回车enter回车查询
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    //导出
    downLoad() {
      let params = {
        oldmanName: this.addForm.oldmanName,
        yearMonth: this.addForm.yearMonth,
        oldTypeName: this.addForm.oldTypeName,
        community: this.addForm.community,
        pageNum: 1,
        pageSize: 99999,
        groupId: this.groupId
      };
      const queryParams = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
      window.location.href =
        baseURL +
        `omc/api/downNotServiceOld?${queryParams}`;
    },

    //搜索查询搜索查询
    queryTable() {
      this.pageNum = 1;
      this.queryPayList();
    },
    //分页
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.groupId = sessionStorage.getItem("groupId");
    this.getAreaList();
    this.queryPayList(); //刷新欠费列表的数据
  },
};
</script>
<style lang="scss" scoped>
.PaymentRecord{
  padding-left: 10px;
  padding-right: 10px;
}
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}

.are {
  color: #369a52;
}

.no {
  color: red;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
